import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import ru from './locales/ru.json';
import uk from './locales/uk.json';
import zh from './locales/zh.json';
import hi from './locales/hi.json';
import ar from './locales/ar.json';
import bn from './locales/bn.json';
import pt from './locales/pt.json';
import ur from './locales/ur.json';
import id from './locales/id.json';
import ja from './locales/ja.json';
import pcm from './locales/pcm.json';
import mr from './locales/mr.json';
import te from './locales/te.json';
import tr from './locales/tr.json';
import ta from './locales/ta.json';
import yue from './locales/yue.json';
import vi from './locales/vi.json';
import tl from './locales/tl.json';
import wuu from './locales/wuu.json';
import ko from './locales/ko.json';
import fa from './locales/fa.json';
import ha from './locales/ha.json';
import sw from './locales/sw.json';
import jv from './locales/jv.json';
import it from './locales/it.json';
import pa from './locales/pa.json';
import gu from './locales/gu.json';
import fi from './locales/fi.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
      ru: { translation: ru },
      uk: { translation: uk },
      zh: { translation: zh },
      hi: { translation: hi },
      ar: { translation: ar },
      bn: { translation: bn },
      pt: { translation: pt },
      ur: { translation: ur },
      id: { translation: id },
      ja: { translation: ja },
      pcm: { translation: pcm },
      mr: { translation: mr },
      te: { translation: te },
      tr: { translation: tr },
      ta: { translation: ta },
      yue: { translation: yue },
      vi: { translation: vi },
      tl: { translation: tl },
      wuu: { translation: wuu },
      ko: { translation: ko },
      fa: { translation: fa },
      ha: { translation: ha },
      sw: { translation: sw },
      jv: { translation: jv },
      it: { translation: it },
      pa: { translation: pa },
      gu: { translation: gu },
      fi: { translation: fi },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
